var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":{"name":"prod-web-en-0.1.88"}};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/hailuo-ai-web/hailuo-en/prod-web-en-0.1.88";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";
const isDev = process.env.NEXT_PUBLIC_BUILD_ENV === 'dev';
const isProd = process.env.NEXT_PUBLIC_BUILD_ENV === 'prod';
const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  enabled: !isDev,
  dsn: sentryDsn,
  environment: isProd ? 'production' : 'test',

  tracesSampleRate: 1,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  release: process.env.NEXT_PUBLIC_TAG,
});



